<template>
  <div ref="rootElement">
    <div v-for="(item, index) in localItems" :key="index" class="mb-3">
      <div class="border border-2 p-3 rounded-3 shadow-sm">
        <div v-if="articleOptions.length" class="mb-3">
          <SearchableDropdown
            :options="articleOptions"
            label="Artikel (Stammdaten)"
            :input-id="`article-${index}`"
            :model-value="selectedArticleKeys[index] || ''"
            @update:modelValue="val => applyArticleSelection(index, val)"
          />
        </div>

        <div class="w-100 d-flex flex-row align-items-end">
          <div class="row g-2 w-100">
            <div class="col-md-6">
              <label for="itemName" class="form-label">
              <span data-bs-toggle="tooltip"
                    :data-bs-title="$t('tooltips.itemName')"
                    class="badge ehw-green">BT-153</span>{{ $t('form.itemName') }}
              </label>
              <input
                  id="itemName"
                  v-model="item.name"
                  @blur="emitUpdate(`tradelineItems[${index}].name`)"
                  class="form-control"
                  :class="{ 'is-invalid': uxStore.hasParsingError(`tradelineItems[${index}].name`) }"
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].name`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].name`) }}
              </div>
            </div>
            <div class="col-md-6">
              <SearchableDropdown
                  :options="masterDataStore.quantityCodes"
                  :label="$t('form.unitCode')"
                  inputId="unitCode"
                  :has-parsing-error="uxStore.hasParsingError(`tradelineItems[${index}].unitCode`)"
                  :modelValue="item.unitCode"
                  @update:modelValue="val => { item.unitCode = val; emitUpdate(`tradelineItems[${index}].unitCode`); }"
                  bt-number="BT-130"
                  :bt-tooltip="$t('tooltips.unitCode')"
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].unitCode`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].unitCode`) }}
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 d-flex flex-row align-items-end mt-3">
          <div class="row g-2 w-100">
            <div class="col-md-4">
              <label for="globalID" class="form-label">
                <span data-bs-toggle="tooltip"
                      :data-bs-title="$t('tooltips.globalID')"
                      class="badge ehw-green">BT-157</span>
                {{ $t('form.globalID') }}
              </label>
              <input
                  id="globalID"
                  v-model="item.globalID"
                  @blur="emitUpdate(`tradelineItems[${index}].globalID`)"
                  class="form-control"
                  :class="{ 'is-invalid': uxStore.hasParsingError(`tradelineItems[${index}].globalID`) }"
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].globalID`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].globalID`) }}
              </div>
            </div>
            <div class="col-md-4">
              <label for="sellerAssignedId" class="form-label">
                <span data-bs-toggle="tooltip"
                      :data-bs-title="$t('tooltips.sellerAssignedId')"
                      class="badge ehw-green">BT-155</span>
                {{ $t('form.sellerAssignedId') }}
              </label>
              <input
                  id="sellerAssignedId"
                  v-model="item.sellerAssignedID"
                  @blur="emitUpdate(`tradelineItems[${index}].sellerAssignedID`)"
                  class="form-control"
                  :class="{ 'is-invalid': uxStore.hasParsingError(`tradelineItems[${index}].sellerAssignedID`) }"
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].sellerAssignedID`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].sellerAssignedID`) }}
              </div>
            </div>
            <div class="col-md-4">
              <SearchableDropdown
                  input-id="categoryCode"
                  :label="$t('form.categoryCode')"
                  :model-value="item.categoryCode"
                  :has-parsing-error="uxStore.hasParsingError(`tradelineItems[${index}].taxCategoryCodes`)"
                  @update:modelValue="val => { item.categoryCode = val; emitUpdate(`tradelineItems[${index}].taxCategoryCodes`); }"
                  :options="masterDataStore.taxCategoryCodes"
                  bt-number="BT-151"
                  :bt-tooltip="$t('tooltips.categoryCode')"
                  required
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].taxCategoryCodes`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].taxCategoryCodes`) }}
              </div>
            </div>

          </div>
        </div>
        <div class="w-100 d-flex flex-row align-items-end mt-3">
          <div class="row g-2 w-100">
            <div class="col-md-3">
              <label for="netUnitPrice" class="form-label">
              <span data-bs-toggle="tooltip"
                    :data-bs-title="$t('tooltips.netUnitPrice')"
                    class="badge ehw-green">BT-146</span>{{ $t('form.netUnitPrice') }}
              </label>
              <input
                  id="netUnitPrice"
                  type="number"
                  step="0.00000000000000001"
                  v-model.number="item.netUnitPrice"
                  @blur="emitUpdate(`tradelineItems[${index}].netUnitPrice`)"
                  class="form-control"
                  :class="{ 'is-invalid': uxStore.hasParsingError(`tradelineItems[${index}].netUnitPrice`) }"
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].netUnitPrice`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].netUnitPrice`) }}
              </div>
            </div>
            <div class="col-md-2">
              <label for="billedQuantity" class="form-label text-nowrap">
              <span data-bs-toggle="tooltip"
                    :data-bs-title="$t('tooltips.billedQuantity')"
                    class="badge ehw-green">BT-129</span>{{ $t('form.billedQuantity') }}
              </label>
              <input
                  id="billedQuantity"
                  step="0.00000000000000001"
                  type="number"
                  v-model.number="item.billedQuantity"
                  @blur="emitUpdate(`tradelineItems[${index}].billedQuantity`)"
                  class="form-control"
                  :class="{ 'is-invalid': uxStore.hasParsingError(`tradelineItems[${index}].billedQuantity`) }"
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].billedQuantity`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].billedQuantity`) }}
              </div>
            </div>
            <div class="col-md-3">
              <label for="netPrice" class="form-label">
                <span data-bs-toggle="tooltip"
                      :data-bs-title="$t('tooltips.netPrice')"
                      class="badge ehw-green">BT-131
                </span>
                {{ $t('form.netPrice') }}
              </label>
              <input
                  disabled
                  id="netPrice"
                  :value="item.netPrice"
                  class="form-control"
              />
            </div>
            <div class="col-md-3">
              <label for="grossPrice" class="form-label">
                {{ $t('form.grossPrice') }}
              </label>
              <input
                  disabled
                  id="grossPrice"
                  :value="computeGrossPrice(item)"
                  class="form-control"
              />
            </div>
            <div class="col-md-1">
              <label for="taxPercent" class="form-label">
                <span data-bs-toggle="tooltip"
                      :data-bs-title="$t('tooltips.tradeLineTax')"
                      class="badge ehw-green">BT-152</span>
                {{ $t('form.taxPercent') }}
              </label>
              <input
                  id="taxPercent"
                  v-model="item.taxPercent"
                  @blur="emitUpdate(`tradelineItems[${index}].taxPercent`)"
                  class="form-control"
                  :class="{ 'is-invalid': uxStore.hasParsingError(`tradelineItems[${index}].taxPercent`) }"
              />
              <div v-if="uxStore.hasParsingError(`tradelineItems[${index}].taxPercent`)" class="invalid-feedback">
                {{ uxStore.getParsingErrorMessage(`tradelineItems[${index}].taxPercent`) }}
              </div>
            </div>
          </div>

          <button
              @click.prevent="removeItem(index)"
              type="button"
              class="btn btn-danger btn-sm ms-2 py-2"
          >
            {{ $t('ui.remove') }}
          </button>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-start mt-3">
      <button data-testid="trade-line-add-item" @click.prevent="addItem" type="button" class="btn btn-secondary">
        {{ $t('ui.addItem') }}
      </button>

      <div class="invoice-summary">
        <div class="p-3 border rounded bg-light h5"
             :class="{ 'is-invalid': uxStore.hasParsingError('GrossTotalAmount') }">

          <div class="d-flex justify-content-between align-items-center mb-1">
            <div>
            <span data-bs-toggle="tooltip"
                  :data-bs-title="$t('tooltips.totalNet')"
                  class="badge ehw-green me-2">BT-109</span>
              <span class="fw-bold me-3">{{ $t('form.totalNet') || 'Total Net' }}:</span>
            </div>
            <span class="text-end ms-3">{{ formatCurrency(calculateTotalNet()) }}</span>
          </div>
          <div class="w-100 border-top mt-1 mb-1 border-1 border-black border-opacity-50"></div>
          <div class="d-flex justify-content-between align-items-center mb-1">
            <div>
            <span data-bs-toggle="tooltip"
                  :data-bs-title="$t('tooltips.totalTax')"
                  class="badge ehw-green me-2">BT-110</span>
              <span class="fw-bold me-3">{{ $t('form.totalTax') || 'Total Tax' }}:</span>
            </div>
            <span class="text-end ms-3">{{ formatCurrency(calculateTotalGross() - calculateTotalNet()) }}</span>
          </div>
          <div class="w-100 border-top mt-1 mb-1 border-1 border-black border-opacity-50"></div>
          <div class="d-flex justify-content-between align-items-center">
            <div>
            <span data-bs-toggle="tooltip"
                  :data-bs-title="$t('tooltips.totalGross')"
                  class="badge ehw-green me-2">BT-115</span>
              <span class="fw-bold me-3">{{ $t('form.totalGross') || 'Total Gross' }}:</span>
            </div>
            <span class="text-end ms-3">{{ formatCurrency(calculateTotalGross()) }}</span>
          </div>
        </div>
        <div v-if="uxStore.hasParsingError('GrossTotalAmount')" class="invalid-feedback pe-3">
          {{ uxStore.getParsingErrorMessage('GrossTotalAmount') }}
        </div>

      </div>
    </div>
  </div>
</template>

<script>import {nextTick, onMounted, ref, watch} from 'vue';
import {Tooltip} from 'bootstrap';
import TradeLineItem from '../../models/TradeLineItem';
import SearchableDropdown from "@/components/Shared/SearchableDropdown.vue";
import {useMasterDataStore} from "@/stores/masterDataStore";
import {useUxStore} from "@/stores/uxStore";

export default {
  name: 'TradeLineItemsForm',
  components: {SearchableDropdown},
  props: {
    standardTaxRate: {
      type: Number,
      default: 19
    },
    items: {
      type: Array,
      default: () => []
    },
    articles: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {emit}) {
    const masterDataStore = useMasterDataStore();
    const uxStore = useUxStore();

    const transformItems = (inputItems) => {
      return inputItems.map(item => {
        const tradeLineItem = item instanceof TradeLineItem ? item : new TradeLineItem(item);
        // If taxPercent is null, use standardTaxRate
        if (tradeLineItem.taxPercent == null) {
          tradeLineItem.taxPercent = props.standardTaxRate;
        }
        return tradeLineItem;
      });
    };

    const localItems = ref(transformItems(props.items));
    const selectedArticleKeys = ref([]);
    const rootElement = ref(null);

    const getArticleKey = (article) => {
      if (!article) {
        return "";
      }
      return (article.articleNumber || article.id || "").toString();
    };

    const articleOptions = ref([]);

    const rebuildArticleOptions = () => {
      const list = Array.isArray(props.articles) ? props.articles : [];
      articleOptions.value = list.map((a) => ({
        id: getArticleKey(a),
        name: a?.name || a?.articleNumber || getArticleKey(a),
        shortName: a?.articleNumber || "",
      }));
    };

    const applyArticleSelection = (index, key) => {
      selectedArticleKeys.value[index] = key || "";

      if (!key) {
        return;
      }

      const list = Array.isArray(props.articles) ? props.articles : [];
      const article = list.find((a) => getArticleKey(a) === key);
      if (!article) {
        return;
      }

      const item = localItems.value[index];
      if (!item) {
        return;
      }

      if (article.name) item.name = article.name;
      if (article.unitCode) item.unitCode = article.unitCode;
      if (article.globalID) item.globalID = article.globalID;
      if (article.articleNumber) item.sellerAssignedID = article.articleNumber;
      if (article.categoryCode) item.categoryCode = article.categoryCode;
      if (article.netUnitPrice !== null && article.netUnitPrice !== undefined) item.netUnitPrice = article.netUnitPrice;
      if (article.taxPercent !== null && article.taxPercent !== undefined) item.taxPercent = article.taxPercent;

      emitUpdate();
    };

    const initializeTooltips = () => {
      nextTick(() => {
        if (rootElement.value) {
          const tooltipTriggerList = rootElement.value.querySelectorAll('[data-bs-toggle="tooltip"]');
          tooltipTriggerList.forEach((tooltipTriggerEl) => {
            new Tooltip(tooltipTriggerEl);
          });
        }
      });
    };

    const emitUpdate = (fieldName) => {
      if (fieldName) {
        uxStore.clearParsingError(fieldName);
      }
      emit('update-items', localItems.value.map(item => item.toJSON()));
    };

    const addItem = () => {
      const newItem = new TradeLineItem({
        name: '',
        unitCode: '',
        sellerAssignedID: '',
        globalID: '',
        grossPrice: 0,
        netUnitPrice: 0,
        billedQuantity: 1,
        categoryCode: '',
        taxPercent: props.standardTaxRate
      });
      localItems.value.push(newItem);
      initializeTooltips();
    };

    const removeItem = (index) => {
      localItems.value.splice(index, 1);
      emitUpdate();
    };

    const computeGrossPrice = (item) => {
      const net = parseFloat(item.netPrice) || 0;
      let tax = parseFloat(item.taxPercent) || 0;

      // If tax is between 0 and 1, treat as fraction (e.g. 0.19 -> 19%)
      if (tax > 0 && tax < 1) {
        tax = tax * 100;
      }

      const value = (net * (1 + tax / 100));
      item.grossPrice = parseFloat(value);
      return value;
    };

    // Add these functions to your setup function:
    const calculateTotalNet = () => {
      return localItems.value.reduce((sum, item) => {
        const netPrice = parseFloat(item.netPrice) || 0;
        return sum + netPrice;
      }, 0);
    };

    const calculateTotalGross = () => {
      return localItems.value.reduce((sum, item) => {
        // Use the actual gross price stored in the item
        const grossPrice = parseFloat(item.grossPrice) || 0;
        return sum + grossPrice;
      }, 0);
    };

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    };

    watch(() => props.items, (newVal) => {
      localItems.value = transformItems(newVal);
    }, {deep: true, immediate: true});

    watch(() => props.articles, () => {
      rebuildArticleOptions();
    }, {deep: true, immediate: true});

    watch(() => localItems.value.length, (len) => {
      if (!Array.isArray(selectedArticleKeys.value)) {
        selectedArticleKeys.value = [];
      }
      if (selectedArticleKeys.value.length < len) {
        selectedArticleKeys.value = selectedArticleKeys.value.concat(Array(len - selectedArticleKeys.value.length).fill(""));
      } else if (selectedArticleKeys.value.length > len) {
        selectedArticleKeys.value = selectedArticleKeys.value.slice(0, len);
      }
    }, {immediate: true});

    onMounted(() => {
      initializeTooltips();
    });

    return {
      localItems,
      masterDataStore,
      uxStore,
      articleOptions,
      selectedArticleKeys,
      rootElement,
      calculateTotalNet,
      calculateTotalGross,
      formatCurrency,
      addItem,
      removeItem,
      emitUpdate,
      applyArticleSelection,
      computeGrossPrice: computeGrossPrice
    };
  }
};

</script>

<style scoped>
.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.invoice-summary {
  min-width: 250px;
  max-width: 500px;
  text-align: right;
}

.is-invalid {
  border-color: #dc3545 !important;
}

.invalid-feedback {
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

</style>
